export { default, links, meta } from "./routes/themenschwerpunkte/$themeId.$themeName.tsx";